//Header function
/*(function() {
  'use strict';
  var header = document.querySelectorAll(".dinamic-header");
  if (!header.length) { return; }
  var headerHeight = header[0].offsetHeight;
  window.onscroll = function() {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollPosition > headerHeight) {
      header[0].classList.add('lsi-header-fixed');
    }else{
      header[0].classList.remove('lsi-header-fixed');
    }
  };
})();
*/
//Menu trigger
(function() {
  'use strict';

  var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
      menu = document.getElementById("main-menu");
  
  var toggleMenu = function() {
      menu.classList.toggle("main-menu-active");
      document.body.classList.toggle("menu-active");
  };

  for (var i = 0; i < menuTrigger.length; i++) {
      menuTrigger[i].addEventListener('click', toggleMenu, false);
  }

  document.addEventListener('keyup', function(e) {
    if (e.keyCode == 27) {
      if (menu.classList.contains('main-menu-active')) {
        menu.classList.toggle("main-menu-active");
        document.body.classList.toggle("menu-active");
      }
    }
  })


})();




/*Resize function*/
(function() {
  'use strict';

  var w = document.querySelector("#width"),
      h = document.querySelector("#height"),
      c = document.querySelector("#calls"),
      calls = 0;

  if (!w) { return; }

  // window.resize callback function
  function getDimensions() {
    w.innerHTML = window.innerWidth;
    h.innerHTML = window.innerHeight;
    calls += 1;
    c.innerHTML = calls;
  }

  //lListen for window.resize
  window.addEventListener('resize', getDimensions);

})();


// call once to initialize page
/*getDimensions();*/






/*var galleryWrap = document.querySelectorAll('.g-wrap');



for (i = 0; i < galleryWrap.length; i++) {
      var elem = galleryWrap[i];
      var child = elem.childNodes;
      
}



const gallerylines = document.querySelectorAll(".-fluid-gallery-line");
var newAppend;

  for (var i = 0; i < gallerylines.length; i++) {
    var childElem = gallerylines[i].childNodes;

    for(i = 0; i < childElem.length; i++ ){
      galleryWrap.append(childElem[i])
    }

  }

  console.log(newAppend);
*/
/*for (i = 0; i < galleryWrap.childNodes.length; i++) {
      child = galleryWrap.childNodes[i];
      console.log(child);
}*/


/*Smooth scroll*/
let smoothScroll = document.querySelector(".smooth-scroll");
if (smoothScroll) {
  var scroll = new SmoothScroll('a.smooth-scroll', {
    speed: 800,
    speedAsDuration: true
  });  
}



/*Accordion toggle*/
$(function() {
  $(".-accordion-filter--toggle").on('click', function(e) {
    /*console.log($(this).find('i')[0].classList.value)*/
    var iconClass = $(this).find('i')[0].classList.value;
    if (iconClass === "fas fa-plus") {
      $(this).find('i')[0].classList.value = "fas fa-minus";
    }else{
      $(this).find('i')[0].classList.value = "fas fa-plus";
    }
    
      //$(this).find('i').text((e, text) => text === "+" ? "-" : "+");
     /*$(this).text((e, text) => text === "+" ? "-" : "+");*/

      $(`#${ $(this).data("toggle-content") }`).stop().slideToggle();
      
  });
});